export const messages = {
  en: {
    editOwnerVoting: {
      title: 'Edit Voting',
      voteName: 'Vote Name',
      voteNamePlaceholder: 'Required, please enter vote name',
      type: 'Type',
      typePlaceholder: 'Required, please select type',
      singleChoice: 'Single Choice',
      multipleChoice: 'Multiple Choice',
      startTime: 'Start Time',
      startTimePlaceholder: 'Required, please select start time',
      endTime: 'End Time',
      endTimePlaceholder: 'Required, please select end time',
      option: 'Option',
      optionPlaceholder: 'Required, please enter option content',
      addOption: 'Add Option',
      deleteOption: 'Delete Option',
      description: 'Description',
      descriptionPlaceholder: 'Required, please enter description',
      voteRooms: 'Vote Rooms',
      houseVote: 'house(s) voting',
      reselect: 'Reselect',
      validate: {
        voteNameRequired: 'Vote name is required',
        voteNameLength: 'Vote name length must be between 1 and 256 characters',
        startTimeRequired: 'Start time is required',
        endTimeRequired: 'End time is required'
      },
      saveSuccess: 'Save successfully',
      saveFailed: 'Save failed'
    },
    selectRooms: {
      title: 'Select Rooms',
      buildingUnit: 'Building Unit',
      roomInfo: 'Room Information',
      unit: 'Unit'
    }
  },
  zh: {
    editOwnerVoting: {
      title: '编辑投票',
      voteName: '投票名称',
      voteNamePlaceholder: '必填，请填写投票名称',
      type: '类型',
      typePlaceholder: '必填，请选择类型',
      singleChoice: '单选',
      multipleChoice: '多选',
      startTime: '开始时间',
      startTimePlaceholder: '必填，请选择开始时间',
      endTime: '结束时间',
      endTimePlaceholder: '必填，请选择结束时间',
      option: '选项',
      optionPlaceholder: '必填，请填写选项内容',
      addOption: '增加选项',
      deleteOption: '删除选项',
      description: '投票说明',
      descriptionPlaceholder: '必填，请输入投票说明',
      voteRooms: '投票房屋',
      houseVote: '户投票',
      reselect: '重新选择',
      validate: {
        voteNameRequired: '名称不能为空',
        voteNameLength: '名称长度必须在1位至256位',
        startTimeRequired: '开始时间不能为空',
        endTimeRequired: '结束时间不能为空'
      },
      saveSuccess: '修改成功',
      saveFailed: '修改失败'
    },
    selectRooms: {
      title: '选择房屋',
      buildingUnit: '楼栋单元',
      roomInfo: '房屋信息',
      unit: '单元'
    }
  },
  'zh-TW': {
    editOwnerVoting: {
      title: '編輯投票',
      voteName: '投票名稱',
      voteNamePlaceholder: '必填，請填寫投票名稱',
      type: '類型',
      typePlaceholder: '必填，請選擇類型',
      singleChoice: '單選',
      multipleChoice: '多選',
      startTime: '開始時間',
      startTimePlaceholder: '必填，請選擇開始時間',
      endTime: '結束時間',
      endTimePlaceholder: '必填，請選擇結束時間',
      option: '選項',
      optionPlaceholder: '必填，請填寫選項內容',
      addOption: '增加選項',
      deleteOption: '刪除選項',
      description: '投票說明',
      descriptionPlaceholder: '必填，請輸入投票說明',
      voteRooms: '投票房屋',
      houseVote: '戶投票',
      reselect: '重新選擇',
      validate: {
        voteNameRequired: '名稱不能為空',
        voteNameLength: '名稱長度必須在1位至256位',
        startTimeRequired: '開始時間不能為空',
        endTimeRequired: '結束時間不能為空'
      },
      saveSuccess: '修改成功',
      saveFailed: '修改失敗'
    },
    selectRooms: {
      title: '選擇房屋',
      buildingUnit: '樓棟單元',
      roomInfo: '房屋信息',
      unit: '單元'
    }
  }
};